export default {
  admin_area_vect_layer: "Admin Area Vect Layer",
  alarm_end_time: "ALM END T",
  alarm_information_query_alm_info_qry: "ALM info QRY",
  alarm_start_time: "ALM ST T",
  area: "Area",
  dev_alarm_source: "Dev Alarm Source",
  dev_info_mgmt: "Dev Info Mgmt",
  dl_template: "DL Template",
  dm: "DM",
  enable: "Enable",
  filter_false_alarm: "F ALM filter",
  handle_and_push: "Handle & push",
  have: " ",
  lat: "Lat",
  linked_devs: "Linked Devs",
  loc: "Loc",
  lon: "Lon",
  lon_lat: "Lon & Lat",
  menu: "Menu",
  nav_to_this_loc: "Nav to this Loc",
  playback_history: "Playback",
  res: "Res",
  resp_person: "Resp Person",
  res_info_mgmt: "Res Info Mgmt",
  res_name: "Res Name",
  res_type: "Res Type",
  rm: "RM",
  show_video: "Live",
  tgt_az_angle: "TGT Az Angle",
  tgt_el_angle: "TGT El Angle",
  tgt_loc: "TGT Loc",
  tgt_lon_lat: "TGT Lon & Lat",
  tgt_point: "TGT Point",
  tgt_type: "TGT Type",
  times: "times",
  tracking: "Tracking",
  ves_dest: "VES Dest",
  ves_lon_lat: "VES Lon & Lat",
  ves_name: "VES Name",
  ves_type: "VES Type",
  video_surveillance_alarmvid_sur_alm: "SURV ALM",
};
